import './ResetFilterOptionButton.scss';

import type { ButtonProps } from '@components/Button';
import Button from '@components/Button';
import { createClsNameMap } from '@utils';

const clsNameMap = createClsNameMap({})('reset-filter-option-button');

export type ResetFilterOptionButtonProps = ButtonProps;

export const ResetFilterOptionButton = ({
  children,
  ...buttonProps
}: ResetFilterOptionButtonProps) => {
  return (
    <Button className={clsNameMap.root()} {...buttonProps}>
      {children}
    </Button>
  );
};
